import "./styleSettings/global.scss";
import "./components/style";
import "./pages/style";

import * as components from "./components";
import * as containers from "./containers";

import Vue, { VueConstructor } from "vue";
import VueMq from "vue-mq";
import log from "loglevel";
import VueDisableInterpolation from "vue-disable-interpolation";

log.setLevel("error");

if (process.env.NODE_ENV === "development") {
  log.setLevel("debug");
}

const Clipfy = {
  install(myVue: VueConstructor) {
    Object.values({
      ...components
    }).forEach((item: any) => {
      myVue.component(item.extendOptions.name, item);
    });

    Object.values({
      ...containers
    }).forEach((item: any) => {
      myVue.component(item.extendOptions.name, item);
    });
  }
};

//
// Vue 用の Media Query
//
// ref: https://alligator.io/vuejs/vue-media-queries/
// src/sccs/settings/_mixin.sccs の数値と同一にしてください。
Vue.use(VueMq, {
  breakpoints: {
    sm: 600, // smartphone
    md: 960, // tablet_x_smartphone or tablet
    lg: Infinity // PC
  }
});

Vue.use(Clipfy);
Vue.use(VueDisableInterpolation);
